import React from 'react'
import { NavLink } from 'react-router-dom'
import { SlHome } from 'react-icons/sl'
import { BsWallet, BsGift } from 'react-icons/bs'
import { FiUser, FiUsers } from 'react-icons/fi'
import { AiOutlineMessage } from 'react-icons/ai'
import { BiMessageSquareDetail } from 'react-icons/bi'

const BottonMenu = ({w3_close}) => {
  return (
    <div className='main_bottom_menus' style={{}}>
      <nav className='bottom_link_main'>
        <NavLink
          exact
          to='/landing'
          className='bottom_link '
          activeClassName='active_link'
          
        >
          {/* <SlHome className='sidebar_link_icon' onClick={w3_close}/> */}
           <img style={{width:'25px'}} src="/home.png"  onClick={w3_close} alt="" />
          <span> Home</span>
        </NavLink>
        <NavLink
          exact
          to='/wallet'
          className='bottom_link '
          activeClassName='active_link'
        >
          {/* <BsWallet className='sidebar_link_icon' onClick={w3_close}/> */}
          <img style={{width:'25px'}} src="/images/icons/wallett.png"  onClick={w3_close} alt="" />

          <span> My wallet</span>
        </NavLink>
        <NavLink
          exact
          to='/refer'
          className='bottom_link '
          activeClassName='active_link'
        >
          
         
            <img style={{width:'25px'}} src="/images/icons/bootom-refer.png"  onClick={w3_close} alt="" />

          <span> Refer</span>
        </NavLink>
        <NavLink
          exact
          to='/support'
          className='bottom_link '
          activeClassName='active_link'
        >
          {/* <BiMessageSquareDetail className='sidebar_link_icon' onClick={w3_close}/> */}
           <img style={{width:'25px'}} src="/images/icons/customer-support.png"  onClick={w3_close} alt="" />

          <span> Support</span>
        </NavLink>
        <NavLink
          exact
          to='/Profile'
          className='bottom_link '
          activeClassName='active_link'
        >
          {/* <FiUser className='sidebar_link_icon'onClick={w3_close} /> */}
        
           <img style={{width:'25px'}} src="/images/icons/bootom_user.png"  onClick={w3_close} alt="" />

          <span> Profile</span>
        </NavLink>
      </nav>
    </div>
  )
}

export default BottonMenu
